import { useClientStore } from "@/store/client";

export const pushProps = () => ({
  pushZones: {
    type: [Array, Object],
    required: false,
    default() {
      return [];
    }
  }
})

export const usePush = (pushZones) => {
  const clientStore = useClientStore();
  const { isPro } = storeToRefs(clientStore);
  const showRecettes = computed(() => {
    return useRuntimeConfig().public.MIAM_SHOW_RECETTES && isPro.value;
  })

  const getPushData = (code, position = 1) => {
    // fonction pour recuperer le contenu html de la zone de push
    const pushElement = pushZones.find(e => (e.code === code && e.position === position))
    return pushElement !== undefined ? pushElement : {}
  }
  const getPushProducts = (code, position, productNumber) => {
    // fonction pour recuperer les produits de push
    const pushElement = pushZones.find(e => (e.code === code && e.position === position));
    return pushElement ? productNumber ? pushElement.products.slice(0, productNumber) : pushElement.products : []
  }
  const getPushList = (code) => {
    // fonction pour recuperer un tableau de contenu html pour une zone de push
    const pushList = pushZones.filter(e => (e.code === code))
    return pushList
  }
  const getPushTitle = (code) => {
    // fonction pour recuperer le titre de la zone de push
    const pushElement = pushZones.find(e => (e.code === code && e.position === 1))
    return pushElement && pushElement.titre !== "null" ? pushElement.titre : ""
  }
  const getPushDataFromTransformed = (code, position = 1) => {
    // fonction pour recuperer le contenu html de la zone de push
    return (
      pushZones[code] &&
      pushZones[code][position] &&
      pushZones[code][position][0]
    ) || {}
  }
  const getPushProductsFromTransformed = (code, position, productNumber) => {
    // fonction pour recuperer les produits de push
    const data = getPushDataFromTransformed(code, position)
    return (
      data &&
      data.products &&
      data.products.slice(0, productNumber)
    ) || []
  }
  const getPushListFromTransformed = (code) => {
    // fonction pour recuperer un tableau de contenu html pour une zone de push
    let list = [];
    if (pushZones && pushZones[code]) {
      Object.entries(pushZones[code]).forEach(
        ([key, value]) => (list = list.concat(value))
      );
    }
    return list;
  }
  const getPushTitleFromTransformed = (code) => {
    // fonction pour recuperer le titre de la zone de push
    const data = getPushDataFromTransformed(code)
    return (
      data &&
      data.titre
    ) || ""
  }

  return {
    showRecettes,
    getPushData,
    getPushProducts,
    getPushList,
    getPushTitle,
    getPushDataFromTransformed,
    getPushProductsFromTransformed,
    getPushListFromTransformed,
    getPushTitleFromTransformed
  }
}
